import glamorous from "glamorous"
import style from "utils/style"

const HeadingSecondary = glamorous.h2({
  fontSize: "1.95rem",
  fontWeight: 700,
  marginBottom: 14,
  padding: "3px 0",
  color: style.colors.darkBrown,
})

export default HeadingSecondary



// WEBPACK FOOTER //
// ./src/elements/HeadingSecondary.js